export enum UserNetworkType {
	LINKEDIN = 'LINKEDIN', // LINKEDIN
	OUTLOOK = 'OUTLOOK', // OUTLOOK
	GOOGLE = 'GOOGLE', // GOOGLE
}
